import {useEffect} from 'react'
import {pageRule} from '../../../invoice-print/core/printLayout'

/** On <html> while the earlier print page is open; ClassicPrint.css scopes its page-wide rules to it. */
export const CLASSIC_PRINT_PAGE_CLASS = 'cp-printing-page'

/**
 * While the earlier print page is open, the browser prints on A4 landscape sheets without margins
 * (the sheets keep their own margins) and the page's print rules apply. Both go when the page
 * closes, so printing anywhere else in the panel is not affected by them.
 */
export const useClassicPrintPage = (title: string) => {
  useEffect(() => {
    const style = document.createElement('style')
    style.setAttribute('data-classic-invoice-print', '')
    style.textContent = pageRule('landscape')
    document.head.appendChild(style)
    document.documentElement.classList.add(CLASSIC_PRINT_PAGE_CLASS)
    return () => {
      style.remove()
      document.documentElement.classList.remove(CLASSIC_PRINT_PAGE_CLASS)
    }
  }, [])

  useEffect(() => {
    const previous = document.title
    document.title = title
    return () => {
      document.title = previous
    }
  }, [title])
}
